import { useEffect, useState } from "react";
import { useMediaQuery } from "usehooks-ts";

/**
 * SSR-safe mobile-viewport check.
 *
 * `useMediaQuery` reads `window.matchMedia` inside its state initializer, so on
 * the client's first render it returns the real viewport value while SSR (no
 * `window`) renders `false`. Gating JSX on that raw value flips the rendered
 * DOM between server and client and triggers React hydration mismatches.
 *
 * This hook holds the SSR value (`false`) until after mount, so the first
 * client render matches the server HTML, then reports the live viewport value
 * on the next render. Pass a custom `query` for non-default breakpoints.
 */
export const useIsMobile = (query = "(max-width: 768px)") => {
  const matches = useMediaQuery(query);
  const [hasMounted, setHasMounted] = useState<boolean>(false);

  useEffect(() => {
    setHasMounted(true);
  }, []);

  return hasMounted && matches;
};
